import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import TransferPaymentType from "./transferPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundOriginalTransferPaymentDetailResponse {
  @observable
  bankTransactionId!: string;

  @observable
  externalBankTransactionId?: string;

  @observable
  variableSymbol?: number;

  @observable
  specificSymbol?: number;

  @observable
  constantSymbol?: number;

  @observable
  @Type(() => Date)
  postingDate!: Date;

  @observable
  messageForRecipient?: string;

  @observable
  additionalInformation?: string;

  @observable
  @Type(() => CounterpartyBankAccountResponse)
  senderBankAccount!: CounterpartyBankAccountResponse;

  @observable
  senderName?: string;

  @observable
  senderAddress?: string;

  @observable
  paidAmount!: number;

  @observable
  transferType!: TransferPaymentType;
}
